import { Button, Indicator, Tooltip } from "@mantine/core";
import { IconBell } from "@tabler/icons-react";
import { setShowNotificationsInRedux } from "../global/globalSlice";
import { useAppDispatch, useAppSelector } from "../hooks";

const getValidTime = (date: Date | string | null | undefined) => {
  if (date == null) {
    return null;
  }

  const time = new Date(date).getTime();
  return Number.isNaN(time) ? null : time;
};

export const NotificationButton = () => {
  const user = useAppSelector((state) => state.globalReducer.user);
  const notifications = user ? user.notifications : [];

  const dispatch = useAppDispatch();

  const hasNewNotifications = () => {
    const lastOpenedDate = localStorage.getItem("notificationsLastOpen");
    const lastOpenedTime = getValidTime(lastOpenedDate);

    if (lastOpenedTime == null) {
      return false;
    }

    return notifications.some((notification) => {
      const createdAtTime = getValidTime(notification.createdAt);
      return createdAtTime != null && createdAtTime > lastOpenedTime;
    });
  };

  const showNotification = useAppSelector((state) => state.globalReducer.showNotifications);

  return (
    <Tooltip label="Vis notifikasjoner" withArrow>
      <Indicator
        disabled={notifications.length === 0 || !hasNewNotifications()}
        inline
        size={10}
        offset={7}
        position="top-start"
        color="orange.5"
      >
        <Button
          variant="subtle"
          c={"white"}
          size="compact-xl"
          onClick={() => {
            const next = !showNotification;
            localStorage.setItem("notificationsLastOpen", new Date().toISOString());
            dispatch(setShowNotificationsInRedux(next));
          }}
        >
          <IconBell size={20} />
        </Button>
      </Indicator>
    </Tooltip>
  );
};
